import React from 'react';
import { Checkbox, Form, Radio } from 'tea-component';
import { useIntl } from 'umi';
import { ResultType } from '../../types';
import BubbleCommon, { aigcDownloadTips } from '@op/components/BubbleCommon';

type AgentOptionsProps = {
  resultType: ResultType;
  setResultType: (value: ResultType) => void;
  hasResultOutput?: boolean;
  needSave?: boolean;
  isSave?: boolean;
  setIsSave?: (value: boolean) => void;
};

export default function ResultOutputForm({
  resultType,
  setResultType,
  hasResultOutput,
  needSave,
  isSave,
  setIsSave,
}: AgentOptionsProps) {
  const { formatMessage } = useIntl();

  if (!hasResultOutput) return null;

  return (
    <Form.Item
      label={formatMessage({ id: 'Result Output' })}
      className="dbo-aigc-radio-wrapper"
    >
      {needSave && (
        <Checkbox value={isSave} onChange={(value) => setIsSave?.(value)} className="dbo-form-line">
          {formatMessage({ id: 'Save to "Summary List"' })}
        </Checkbox>
      )}
      <Radio.Group
        value={resultType}
        onChange={(value: any) => setResultType(value)}
      >
        <Radio name="download" className="radio-item">
          {formatMessage({ id: 'Download' })}
          <BubbleCommon
            tipsMap={aigcDownloadTips}
            placement="top"
          ></BubbleCommon>
        </Radio>
        <Radio name="page">{formatMessage({ id: 'Show on page' })}</Radio>
        {/* <Radio name="gpt" className="radio-item">
                {formatMessage({ id: 'GPT Auto Report' })}
              </Radio> */}
      </Radio.Group>
    </Form.Item>
  );
}
